import React from "react";
import { useTranslation } from "react-i18next";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  Row,
  Col,
  Label,
} from "reactstrap";
const ApproveModal = (prop) => {
  const { t } = useTranslation();
  return (
    <Modal
      isOpen={prop.modal}
      toggle={() => prop.setModal(!prop.modal)}
      className="modal-dialog-centered modal-md"
    >
      <ModalHeader
        className="bg-transparent"
        toggle={() => {
          prop?.resetForm();
          prop.setModal(!prop.modal);
        }}
      ></ModalHeader>
      <ModalBody className="px-sm-5 mx-50 pb-5">
        <div className="text-center mb-2">
          <h1> {t(prop.title)}</h1>
        </div>

        <Row tag="form" className="gy-1" onSubmit={prop.handleSubmit}>
          <Col xs={12}>
            <div className="text-center mb-2">{prop.description}</div>
          </Col>

          <Col xs={12} className="text-center">
            <Button type="submit" className="me-1" color="success">
              {t("Kaydet")}
            </Button>
            <Button
              type="reset"
              color="danger"
              outline
              onClick={() => {
                prop.setModal(!prop.modal);
              }}
            >
              {t("İptal Et")}
            </Button>
          </Col>
        </Row>
      </ModalBody>
    </Modal>
  );
};

export default ApproveModal;
